<template>
  <div class="pdf-view">
    <div class="pdf-view-actions">
      <div class="pdf-view-page">
        <span class="pagina">
          Página:
        </span>
        <span>{{ page_num }} / {{ page_count }}</span>
      </div>
      <v-layout class="pdf-view-buttons" align-center>
        <v-btn
          dark
          small
          class="pa-1"
          :disabled="page_num == 1"
          @click="onPrevPage">
          <span class="label-btn">Página Anterior</span>
          <v-icon>
            chevron_left
          </v-icon>
          </v-btn>
        <v-btn
          dark
          small
          class="pa-1"
          :disabled="page_num == page_count"
          @click="onNextPage">
          <span class="label-btn">Página Siguiente</span>
          <v-icon>
            chevron_right
          </v-icon>
        </v-btn>
        <!-- <v-btn
          v-if="url"
          fab
          dark
          icon
          small
          @click="descargar()">
          <v-icon>file_download</v-icon>
        </v-btn> -->
      </v-layout>
    </div>
    <!-- <div class="pdf-viev-content"> -->
    <div class="pdf-viev-content">
      <div class="pdf-view-content-back">
        <canvas :id="id" class="elevation-2">Cargando PDF espere por favor...</canvas>
      </div>
    </div>
    <div class="pdf-view-footer"></div>
  </div>
</template>

<script>
import PDFJS from 'pdfjs-dist';

export default {
  props: {
    data: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: 'app-pdf-viewer'
    },
    url: {
      type: String,
      default: ''
    },
    storage: {
      type: Number,
      default: 0
    },
    fileName: {
      type: String,
      default: 'doc'
    }
  },
  data () {
    return {
      page_num: 0,
      page_count: 0
    };
  },
  created () {
    this.pdfDoc = null;
    this.pageNum = 1;
    this.pageRendering = false;
    this.pageNumPending = null;
    this.scale = 1.6;
  },
  mounted () {
    this.canvas = document.getElementById(this.id);
    this.ctx = this.canvas.getContext('2d');

    if (this.data) {
      this.render(this.data);

      // if (this.storage) {
      //   window.localStorage.setItem(`pdf-${this.storage}`, this.data);
      // }
    }
  },
  methods: {
    render (data) {
      // let pdfData = atob(btoa(String.fromCharCode(...new Uint8Array(data))));
      let pdfData = atob(data);
      // Disable workers to avoid yet another cross-origin issue (workers need
      // the URL of the script to be loaded, and dynamically loading a cross-origin
      // script does not work).
      // PDFJS.disableWorker = true;

      // The workerSrc property shall be specified.
      // PDFJS.workerSrc = '//mozilla.github.io/pdf.js/build/pdf.worker.js';
      PDFJS.GlobalWorkerOptions.workerSrc = require('pdfjs-dist/build/pdf.worker.entry.js');
      // Using DocumentInitParameters object to load binary data.
      let loadingTask = PDFJS.getDocument({ data: pdfData });
      loadingTask.promise.then(pdsfDoc_ => {
        this.pdfDoc = pdsfDoc_;
        this.page_count = this.pdfDoc.numPages;

        // Initial/first page rendering
        this.renderPage(this.pageNum);
      }, function (error) {
        // PDF loading error
        console.error('Error PDF', error);
      });
    },
    /**
     * Get page info from document, resize canvas accordingly, and render page.
     * @param num Page number.
     */
    renderPage (num) {
      this.pageRendering = true;
      // Using promise to fetch the page
      this.pdfDoc.getPage(num).then(page => {
        var viewport = page.getViewport({scale: this.scale});
        this.canvas.height = viewport.height;
        this.canvas.width = viewport.width;

        // Render PDF page into canvas context
        var renderContext = {
          canvasContext: this.ctx,
          viewport: viewport
        };
        var renderTask = page.render(renderContext);

        // Wait for rendering to finish
        renderTask.promise.then(() => {
          this.pageRendering = false;
          if (this.pageNumPending !== null) {
            // New page rendering is pending
            this.renderPage(this.pageNumPending);
            this.pageNumPending = null;
          }
        });
      });

      // Update page counters
      this.page_num = num;
    },
    /**
     * If another page rendering in progress, waits until the rendering is
     * finised. Otherwise, executes rendering immediately.
     */
    queueRenderPage (num) {
      if (this.pageRendering) {
        this.pageNumPending = num;
      } else {
        this.renderPage(num);
      }
    },
    /**
     * Displays previous page.
     */
    onPrevPage () {
      if (this.pageNum <= 1) {
        return;
      }
      this.pageNum--;
      this.queueRenderPage(this.pageNum);
    },
    /**
     * Displays next page.
     */
    onNextPage () {
      if (this.pageNum >= this.pdfDoc.numPages) {
        return;
      }
      this.pageNum++;
      this.queueRenderPage(this.pageNum);
    },
    descargar () {
      if (this.url) {
        this.$service.get(this.url)
        .then((response) => {
          console.log('PDF FILE', response);
          const url = window.URL.createObjectURL(this.b64toBlob(response.base64, 'application/pdf'));
          const link = document.createElement('a');
          link.href = url;
          const d = new Date();
          link.setAttribute('download', `BORRADOR-${d.getTime()}.pdf`);
          document.body.appendChild(link);
          link.click();
        });
      }
    },
    b64toBlob (b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      let byteCharacters = atob(b64Data);
      let byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);

        let byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        let byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      let blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }
  }
};
</script>

<style lang="scss">
@import '../../assets/scss/_variables.scss';
.label-btn {
  font-size: 0.9em;
}
.v-btn {
  min-width: 44px!important;
}
.pdf-view {
  canvas {
    box-sizing: border-box;
    width: 100%;
    border: 1px solid #ddd;
  }

  .pdf-view-actions {
    background: darken(#4D4D4D, 0%);
    color: white;
    overflow: hidden;
    height: 48px;

    .pdf-view-buttons {
      float: right;
      padding-right: 10px;
    }

    .pdf-view-page {
      float: left;
      line-height: 46px;
      padding-left: 20px;
      font-size: 1.0rem;
    }
  }
}
.pdf-viev-content {
  overflow-y: scroll;
  height: 1000px;
}
.pdf-view-content-back {
  padding-left: 56px;
  padding-right: 56px;
  padding-top: 12px;
  padding-bottom: 12px;
  background:#838383;
}
.pdf-view-footer {
  background: darken(#4D4D4D, 0%);
  height: 24px;
}
.pagina {
  display: show;
}
@media screen and (max-height: 1500px) {
  .pdf-viev-content {
    overflow-y: scroll;
    height: 720px;
  }
}
@media screen and (max-height: 1200px) {
  .pdf-viev-content {
    overflow-y: scroll;
    height: 500px;
  }
}
@media screen and (max-height: 900px) {
  .pdf-viev-content {
    overflow-y: scroll;
    height: 460px;
  }
}
@media screen and (max-height: 700px) {
  .pdf-viev-content {
    overflow-y: scroll;
    height: 280px;
  }
  .pagina {
    display: none;
  }
  .pdf-view-content-back {
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 0px;
    padding-bottom: 0px;
  }
}
@media screen and  (max-height: 500px) {
  .pdf-viev-content {
    overflow-y: scroll;
    height: 140px;
  }
  .pagina {
    display: none;
  }
  .pdf-view-content-back {
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 0px;
    padding-bottom: 0px;
  }
}
@media screen and  (max-height: 300px) {
  .pdf-viev-content {
    overflow-y: scroll;
    height: 110px;
  }
  .pagina {
    display: none;
  }
  .pdf-view-content-back {
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 0px;
    padding-bottom: 0px;
  }
}
@media only screen and  (max-width: 500px) {
  .pdf-viev-content {
    overflow-y: scroll;
    height: 300px;
  }
  .pagina {
    display: none;
  }
  .pdf-view-content-back {
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 0px;
    padding-bottom: 0px;
  }
}
@media only screen and  (max-width: 900px) {
  .label-btn {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/util/PdfView.vue